import type { EmptyStateToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useEmptyStateTokens = (theme: Theme): EmptyStateToken => {
  const { color, borderRadius, component } = theme;
  const base = {
    borderColor: color.outline,
    backgroundColor: color.surface,
    borderRadius: borderRadius.xl,
  };

  return merge({}, base, component?.emptyState) as EmptyStateToken;
};
